import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import {Button, Modal} from "react-bootstrap";
import Loading from "../../components/loading";
import {Form, Formik} from "formik";
import {transactionRequestSchema, userUserGroupRoleRequest} from "../../utils/schemas";
import FormGroup from "../../components/form-group";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {useGlobalNotificationMessage} from "../../context/message";
import {useTransactionService} from "../../services/transaction-service";
import {useUserService} from "../../services/user-service";
import {AppRoles, AppRoleTypes, TransactionType} from "../../utils/constants";
import Select from "react-select";

const AddEditTransactionModal = forwardRef( ({onSuccess=null, ...props}, ref) => {
  const [show, setShow] = useState(false);
  const [model, setModel] = useState();
  const [loading, setLoading] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [reset, setReset] = useState(0);

  let formSchema = transactionRequestSchema;

  let transactionService = useTransactionService();
  let userService = useUserService();

  //expose api for interacting with component
  useImperativeHandle(ref, () => ({
    openModal: openModal,
    closeModal: closeModal,
  }));

  const openModal = (model=null) => {
    setLoading(true);

    let promises = [
      Promise.resolve('initOk'),
      Promise.resolve(userService.getList())
    ];

    if (model && model.id){
      promises.push(getDetail(model.id));
    }

    Promise.all(promises).then(([init=null, users=[], detail= {}])=>{
      setUsersList(users ? users.map((g)=>{g.label=g.name; g.value=g.id; return g;}) : []);

      let newDetail = Object.assign({}, detail);
      setModel(formSchema.cast(newDetail));
      setLoading(false);
    });

    setShow(true);
  }
  const closeModal = () => {
    setShow(false);
    setReset(reset+1);
    setModel(formSchema.cast());
  }

  const getDetail = (id) => {
    return transactionService.getDetail(id);
  }

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    const reqValues = values;

    transactionService.addEditModel(reqValues, reqValues.id)
      .then((res) => {
        if (onSuccess && 'function' === typeof onSuccess){
          onSuccess(res);
        }
        closeModal();
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa uložiť zmeny.");
        HelperService.handleFormErrors(error, setErrors);
      })
      .finally(()=>{ setSubmitting(false);});
  };

  return (
    <>
      <Formik
        key={reset}
        enableReinitialize={true}
        initialValues={formSchema.cast(model) || formSchema.cast()}
        validationSchema={formSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, errors, touched, handleSubmit, setFieldValue, values}) => (

          <Modal size='lg' show={!!show} onHide={closeModal} centered>
            <Modal.Header closeButton>
              { model && <Modal.Title>{ !model.id ? 'Nová transakcia' : 'Úprava transakcie' }</Modal.Title>}
            </Modal.Header>
            <Modal.Body>
              <Section animation={HelperService.getRandomAnimation()}>

                {loading && <Loading className="m-2" />}

                {!loading && <Form className="row">

                  <FormGroup
                      name="type"
                      type="select"
                      options={Object.values(TransactionType)}
                      optionLabel="title"
                      optionKey="val"
                      placeholder="typ"
                      label="Typ"
                      className="col-md-12"
                      touched={touched} errors={errors} schema={formSchema}
                  />

                  <FormGroup
                      name="user_id"
                      type="select"
                      options={usersList}
                      placeholder="Vyberte používateľa"
                      label="Používateľ"
                      className="col-md-4"
                      touched={touched} errors={errors} schema={formSchema}
                  />

                  <FormGroup
                      name="value_at"
                      type="date"
                      placeholder="Dátum"
                      label="Dátum"
                      className="col-md-4"
                      touched={touched} errors={errors} schema={formSchema}
                  />

                  <FormGroup
                    name="value"
                    placeholder="Hodnota"
                    label="Hodnota"
                    className="col-md-4"
                    touched={touched} errors={errors} schema={formSchema}
                  />

                  <div className="clearfix"></div>

                </Form>}

              </Section>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={closeModal}>Zatvoriť</Button>
              <Button type="submit" variant="primary" onClick={handleSubmit} disabled={isSubmitting}>Odoslať</Button>
            </Modal.Footer>
          </Modal>
        )}
      </Formik>

    </>
  );
});

export default AddEditTransactionModal;
